import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"

// Import modules folder
const modules = {};
const files = require.context('./modules/', true, /\.js$/i);
files.keys().map(key => {    
    let moduleName = key.split('/').pop().split('.')[0];
    let module = require(`./modules/${moduleName}`);
    modules[`${moduleName}`] = module.default;
});

Vue.use(Vuex)

export default new Vuex.Store({
    modules,

    state, // data

    getters, // computed

    actions, // methods

    mutations // setter for state
})
